// extracted by mini-css-extract-plugin
export default {"adjAlert":"QuotingCockpit_adjAlert__nIYQJ"};